import { jsx as C } from "react/jsx-runtime";
const H = () => /* @__PURE__ */ C(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.25 3C2.25 2.58579 2.58579 2.25 3 2.25H5.5C5.85467 2.25 6.16085 2.49843 6.23391 2.84549L8.0144 11.3028L13.6069 7.86126C13.8068 7.73826 14.0527 7.71591 14.2715 7.80087C14.4903 7.88583 14.6567 8.0683 14.7211 8.29396L15.4559 10.8658L20.6221 7.85217C20.8541 7.71685 21.1407 7.71589 21.3735 7.84964C21.6064 7.9834 21.75 8.23145 21.75 8.5V21C21.75 21.4142 21.4142 21.75 21 21.75H3C2.58579 21.75 2.25 21.4142 2.25 21V3ZM4.25 15.5C4.25 14.8096 4.80964 14.25 5.5 14.25H9.5C10.1904 14.25 10.75 14.8096 10.75 15.5V17.5C10.75 18.1904 10.1904 18.75 9.5 18.75H5.5C4.80964 18.75 4.25 18.1904 4.25 17.5V15.5ZM5.75 15.75V17.25H9.25V15.75H5.75ZM13.5 14.25C12.8096 14.25 12.25 14.8096 12.25 15.5V17.5C12.25 18.1904 12.8096 18.75 13.5 18.75H17.5C18.1904 18.75 18.75 18.1904 18.75 17.5V15.5C18.75 14.8096 18.1904 14.25 17.5 14.25H13.5ZM13.75 17.25V15.75H17.25V17.25H13.75Z",
    fill: "currentColor"
  }
);
export {
  H as default
};
